const urlToFile = async (url, filename, mimeType) => {
  if (!url) throw new Error('url cannot be empty');
  if (!filename) throw new Error('filename cannot be empty');
  if (!mimeType) throw new Error('mimeType cannot be empty');

  const res = await fetch(url);
  const buffer = await res.arrayBuffer();

  return new File([buffer], filename, { type: mimeType });
};

export default urlToFile;
